import React from "react";
import userInterfaceSvg from "./svg-icon/userInterface";
import styles from "../styles/home/Home.CardTour.module.scss";

/* eslint sonarjs/cognitive-complexity: "off" */
export const starsArray = (
    rating: string | undefined | number,
    isBig = false
) => {
    const fullStars = Math.floor(+(rating ?? "0"));
    const halfStar = +(rating ?? "0") % 1 === 0.5;
    const quartStar =
        +(rating ?? "0") % 1 >= 0.25 && +(rating ?? "0") % 1 < 0.5;
    const quartToStar = +(rating ?? "0") % 1 >= 0.5;

    const array: React.ReactNode[] = [];

    for (let i = 0; i < fullStars; i++) {
        array.push(
            <userInterfaceSvg.StarFilledCustom
                className={`${styles.colorSvg} me-1`}
                width={`${isBig ? "25" : "12.5"}`}
                height={`${isBig ? "25" : "12.5"}`}
                viewBox="0 2 25 25"
            />
        );
    }
    if (halfStar) {
        array.push(
            <userInterfaceSvg.StarHalfFilled
                className={`${styles.colorSvg} me-1`}
                width={`${isBig ? "25" : "12.5"}`}
                height={`${isBig ? "25" : "12.5"}`}
                viewBox="0 2 25 25"
            />
        );
    } else if (quartStar) {
        array.push(
            <userInterfaceSvg.StarQuartFilled
                className={`${styles.colorSvg} me-1`}
                width={`${isBig ? "25" : "12.5"}`}
                height={`${isBig ? "25" : "12.5"}`}
                viewBox="0 2 25 25"
            />
        );
    } else if (quartToStar) {
        array.push(
            <userInterfaceSvg.StarQuartToFilled
                className={`${styles.colorSvg} me-1`}
                width={`${isBig ? "25" : "12.5"}`}
                height={`${isBig ? "25" : "12.5"}`}
                viewBox="0 2 25 25"
            />
        );
    }
    return array;
};
